import { useContext, useState, useEffect, useMemo } from "react";
import { IdentityContext } from "../context/identity-context";

/**
 * Hook to fetch reservations using a ListingCalendarService instance.
 * Handles issuer, AdminListingOfficer, and AdminAdcu users automatically.
 */
export default function useReservations(listingCalendarService) {
  const { user } = useContext(IdentityContext);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoize service for stability
  const service = useMemo(() => listingCalendarService, [listingCalendarService]);

  useEffect(() => {
    let mounted = true;

    async function fetchReservations() {
      setLoading(true);
      setError(null);

      try {
        const entityId = user?.attributes?.["custom:entity_id"];
        const displayName = user?.attributes?.["custom:display_name"] || "";
        let resp;

        console.log("Entity ID:", entityId);
        console.log("Display Name:", displayName);

        // Extract type from displayName
        if (displayName.includes("(Listing Officer)")) {
          resp = await service.adminLoGetReservations("(Listing Officer)");
        } else if (displayName.includes("(Adcu)")) {
          resp = await service.adcuGetReservations("(Adcu)");
        } else if (entityId) {
          resp = await service.issuerGetReservations(entityId);
        } 

        const payload = resp && (resp.data !== undefined ? resp.data : resp);

        let items = [];
        if (Array.isArray(payload)) items = payload;
        else if (payload) {
          if (Array.isArray(payload.items)) items = payload.items;
          else if (Array.isArray(payload.reservations)) items = payload.reservations;
          else if (Array.isArray(payload.data)) items = payload.data;
          else if (typeof payload === "object" && payload.id) items = [payload];
        }

        if (mounted) setReservations(items);
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load reservations";
        if (mounted) setError(msg);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchReservations();

    return () => {
      mounted = false;
    };
  }, [service, user]);

  return { reservations, setReservations, loading, error };
}
